// TODO move to constants
const patterns = {
  phone:
    /(\+[0-9]|8)[- _]*\(?[- _]*(\d{3}[- _]*\)?([- _]*\d){7}|\d\d[- _]*\d\d[- _]*\)?([- _]*\d){6})(#+[0-9])?/g,
  kpp: /^([0-9]{1}[1-9]{1}|[1-9]{1}[0-9]{1})([0-9]{2})([0-9A-F]{2})([0-9]{3})?$/,
  verificationDocNameExt: /\.(pdf|jpe?g|tiff?|png)$/i,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/,
  gsmEncoding:
    /^[0-9a-zA-Z@Δ¡¿£_!Φ"¥Γ#èΛ¤éΩ%ùΠ&ìΨòΣçΘΞ:Ø;ÄäøÆ,<Ööæ=ÑñÅß>ÜüåÉ§à€~ $.\-+()*\\/?|^}{[\]'\r\n]*$/,
  sipUri: /^(sip:)?[A-Za-z0-9\-.%!$&*+/=?^_`{|}~]+@[^@\s]+(?::\d+)?$/i,
  correctAmoCrmDomain: /\.amocrm\.[a-z]{2,3}$/,
  amoCrmDomain: /^https?:\/\/(.+\.amocrm\.[a-z]{2,3})$/,
  correctBitrixCrmDomain: /(^https?:\/\/)?([a-z0-9а-яё-]+\..*[a-z]+)(\/)?$/i,
};

export { patterns };
